import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=78b3dfda&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"
import style0 from "./customer_list.vue?vue&type=style&index=0&id=78b3dfda&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b3dfda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b3dfda')) {
      api.createRecord('78b3dfda', component.options)
    } else {
      api.reload('78b3dfda', component.options)
    }
    module.hot.accept("./customer_list.vue?vue&type=template&id=78b3dfda&scoped=true", function () {
      api.rerender('78b3dfda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/new_product_apply/form/customer_list.vue"
export default component.exports